import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditContractOrder = ({ itemId, handleClose, show }) => {
  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState({});
  const [locationLoading, setLocationLoading] = useState([]);
  const [shippingAddress, setShippingAddress] = useState([]);
  const [loading, setLoading] = useState(false);



  const [formData, setFormData] = useState({
    id: '',
    contract: '',
    po_number: '',
    shipping_address: '',
    processing_line: "",
    quantity: "",
    price:'',
    loading_type: "",
    lot_number: "",
    status: "",
    shipping_method: "",

  });

  // Populate form data when itemId changes
  useEffect(() => {
   
    
    if (itemId && itemId.id) {
      
      setFormData({
        id: itemId.id || '',
        contract: itemId.contract || '',
        // Fixed: Handle nested shipping address data properly
        shipping_address: itemId.ship_address2?.id || itemId.shipping_address || '',
        processing_line: itemId.order_location?.id || itemId.processing_line || '',
        quantity: itemId.quantity || '',
        price: itemId.price || '',
        po_number: itemId.po_number || '',
        loading_type: itemId.loading_type || '',
        lot_number: itemId.lot_number || '',
        status: itemId.status?.id || itemId.status || '',
        shipping_method: itemId.shipping_method || '',
       
      });
    } else {
      // Reset form if no itemId
      setFormData({
        id: '',
        contract: '',
        po_number:'',
        shipping_address: '',
        processing_line: "",
        quantity: "",
        price: "",
        loading_type: "",
        lot_number: "",
        status: "",
        shipping_method: "",
        
      });
    }
   

  }, [itemId]);

  // Load dropdown data when component mounts or show changes
  useEffect(() => {
    console.log("=== useEffect for loading dropdown data ===");
    
    // Only load data when modal is shown
    if (!show) return;
    
    const contractId = itemId?.contract || formData.contract;

    if (contractId) {
      // Load shipping addresses
      axios
        .post(`/contracts/addresses/listing/${contractId}`, {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          console.log("Shipping addresses API response:", response.data);
          
          if (response.data.code === 200) {
            let addresslist = response.data.data.address;
            console.log("Raw address list:", addresslist);
            
            if (Array.isArray(addresslist)) {
              let addresses = addresslist.map((customer, index) => ({
                label: customer.name,
                value: customer.id,
                key: `address-${index}`,
              }));
              setShippingAddress(addresses);
              console.log("Processed shipping addresses:", addresses);
            } else {
              console.log("Address list is not an array:", addresslist);
              setShippingAddress([]);
            }
          } else {
            console.log("API returned non-200 code:", response.data.code);
            setShippingAddress([]);
          }
        })
        .catch((error) => {
          console.error("Error loading shipping addresses:", error);
          toast.error("Failed to load shipping addresses");
          setShippingAddress([]);
        });
    } else {
      console.log("No contract ID available, clearing shipping addresses");
      setShippingAddress([]);
    }

    // Load processing locations
    axios.get(`/helpers/loading-locations-new`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    }).then((response) => {
      console.log("Processing locations API response:", response.data);
      
      if (response.data.code === 200) {
        let locations = response.data.data.locations;
        
        if (Array.isArray(locations)) {
          let locationslist = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `location-${index}`,
          }));
          setLocationLoading(locationslist);
        } else {
          setLocationLoading([]);
        }
      } else {
        setLocationLoading([]);
      }
    })
    .catch((error) => {
      console.error("Error loading processing locations:", error);
      toast.error("Failed to load processing locations");
      setLocationLoading([]);
    });
  }, [show, itemId?.contract, formData.contract]); // Added show and contract as dependencies

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData({ ...formData, [name]: value });
    setBackendErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.id) {
      toast.error("Order ID is missing. Cannot update order.");
      return;
    }

    // Basic validation
    if (!formData.shipping_address) {
      toast.error("Please select a shipping address.");
      return;
    }

    setLoading(true);
    
    // Use PUT method for updating
    axios
      .post(`/contracts/orders/update`, formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log("Update response:", response);
        setLoading(false);
        
        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
            handleClose();
            window.location.reload(); // Consider using a callback instead
          }, 1000);
        } else {
          setBackendErrors(response.data.error || {});
          toast.error(response.data.message || "Failed to update order");
        }
      })
      .catch((error) => {
        console.error("Update error:", error);
        setLoading(false);
        
        if (error.response && error.response.data) {
          setBackendErrors(error.response.data.error || {});
          toast.error(error.response.data.message || "Error updating order");
        } else {
          toast.error("Network error. Please try again.");
        }
      });
  };

  const customHandleInput = (event) => {
    const inputName = event.target.name;
    setBackendErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[inputName];
      return newErrors;
    });
  };


  return (
    <>
      <Modal centered show={show} onHide={handleClose} size="lg">
        <Modal.Header>
          <h4 className="modal-title">Edit Order</h4>
          <button
            type="button"
            className="close"
            data-bs-dismiss="modal"
            onClick={handleClose}
            aria-hidden="true"
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <ToastContainer />
            {backendSuccess && (
              <div className="alert alert-success mt-1">{backendSuccess}</div>
            )}
            
            <div className="row">
              <div className="col-md-6">
              <div className="form-group" style={{paddingTop:'10px'}}>
              <label style={{marginBottom:'0px'}}>PO Number</label>
              <input
                className="form-control form-white"
                type="text"
                name="po_number"
                value={formData.po_number}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                }}
               
              />
              {backendErrors.po_number && (
                <small className="form-error mt-1">{backendErrors.po_number}</small>
              )}
            </div>

            </div>

              {/* Shipping Address */}
              <div className="col-md-6">
                <div className="form-group" style={{paddingTop:'10px'}}>
                  <label style={{marginBottom:'0px'}}>Select Shipping Address</label>
                  <select
                    className="form-control form-white"
                    name="shipping_address"
                    value={formData.shipping_address}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    {shippingAddress.length > 0 ? (
                      shippingAddress.map((address) => (
                        <option key={address.key} value={address.value}>
                          {address.label}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>No addresses available</option>
                    )}
                  </select>
                  {backendErrors.shipping_address && (
                    <small className="form-error mt-1 text-danger">{backendErrors.shipping_address}</small>
                  )}
                 
                </div>
              </div>
              
              {/* Processing Line */}
              <div className="col-md-6">
                <div className="form-group" style={{paddingTop:'10px'}}>
                  <label style={{marginBottom:'0px'}}>Select Processing Line</label>
                  <select
                    className="form-control form-white"
                    name="processing_line"
                    value={formData.processing_line}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    {locationLoading.length > 0 ? (
                      locationLoading.map((location) => (
                        <option key={location.key} value={location.value}>
                          {location.label}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>No locations available</option>
                    )}
                  </select>
                  {backendErrors.processing_line && (
                    <small className="form-error mt-1 text-danger">{backendErrors.processing_line}</small>
                  )}
                </div>
              </div>

              {/* Quantity */}
              <div className="col-md-6">
                <div className="form-group" style={{paddingTop:'10px'}}>
                  <label style={{marginBottom:'0px'}}>Quantity</label>
                  <input
                    className="form-control form-white"
                    type="text"
                    name="quantity"
                    value={formData.quantity}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                    onKeyPress={(event) => {
                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {backendErrors.quantity && (
                    <small className="form-error mt-1 text-danger">{backendErrors.quantity}</small>
                  )}
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="form-group" style={{paddingTop:'10px'}}>
                  <label style={{marginBottom:'0px'}}>Price</label>
                  <input
                    className="form-control form-white"
                    type="text"
                    name="price"
                    value={formData.price}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                    onKeyPress={(event) => {
                      if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {backendErrors.price && (
                    <small className="form-error mt-1 text-danger">{backendErrors.price}</small>
                  )}
                </div>
              </div>
           
              {/* Loading Status */}
              <div className="col-md-6">
                <div className="form-group" style={{paddingTop:'10px'}}>
                  <label style={{marginBottom:'0px'}}>Select Loading Type</label>
                  <select
                    className="form-control form-white"
                    name="loading_type"
                    value={formData.loading_type}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="1">Floor Loaded</option>
                    <option value="2">Pallets Loaded</option>
                  </select>
                  {backendErrors.loading_type && (
                    <small className="form-error mt-1 text-danger">{backendErrors.loading_type}</small>
                  )}
                </div>
              </div>

              {/* Lot Number */}
              <div className="col-md-6">
                <div className="form-group" style={{paddingTop:'10px'}}>
                  <label style={{marginBottom:'0px'}}>Lot Number</label>
                  <input
                    className="form-control form-white"
                    type="text"
                    name="lot_number"
                    value={formData.lot_number}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                  />
                  {backendErrors.lot_number && (
                    <small className="form-error mt-1 text-danger">{backendErrors.lot_number}</small>
                  )}
                </div>
              </div>

              {/* Order Status */}
              <div className="col-md-6">
                <div className="form-group" style={{paddingTop:'10px'}}>
                  <label style={{marginBottom:'0px'}}>Select Order Status</label>
                  <select
                    className="form-control form-white"
                    name="status"
                    value={formData.status}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="1">Confirmed</option>
                    <option value="2">Finished</option>
                    <option value="3">In Process</option>
                    <option value="4">Draft</option>
                    <option value="5">Cancelled</option>
                    <option value="6">Shipped</option>
                    <option value="7">Delivered</option>
                  </select>
                  {backendErrors.status && (
                    <small className="form-error mt-1 text-danger">{backendErrors.status}</small>
                  )}
                </div>
              </div>
       
              {/* Shipping Method */}
              <div className="col-md-6">
                <div className="form-group" style={{paddingTop:'10px'}}>
                  <label style={{marginBottom:'0px'}}>Select Shipping method</label>
                  <select
                    className="form-control form-white"
                    name="shipping_method"
                    value={formData.shipping_method}
                    onChange={(e) => {
                      handleChange(e);
                      customHandleInput(e);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="Truck">Truck</option>
                    <option value="Container">Container</option>
                    <option value="EXW">EXW</option>
                  </select>
                  {backendErrors.shipping_method && (
                    <small className="form-error mt-1 text-danger">{backendErrors.shipping_method}</small>
                  )}
                </div>
              </div>
            </div>

            <div className="submit-section" style={{paddingTop:'20px'}}>
              <button 
                type="submit" 
                className="btn btn-primary submit-btn"
                disabled={loading || !formData.id}
              >
                {loading ? 'UPDATING...' : 'UPDATE ORDER'}
              </button>
              <button 
                type="button" 
                className="btn btn-secondary ms-2"
                onClick={handleClose}
              >
                CANCEL
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

EditContractOrder.propTypes = {
  itemId: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default EditContractOrder;